import axios from "axios";
import '../utils/axios.interceptor';
import { urlCoreBack } from "../../project/configs/config";
const epName = "v1/medico/";
const nameItemsText = "Medicos";
const nameItemText = "Medico";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getMedicos = async (params) => {
	let _params = {};
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

	if (params) {

		if (params.idMedico) {
			_params.id = params.idMedico;
		}

		if (params.nombre) {
			_params.nombre = params.nombre;
		}

		if (params.apellido) {
			_params.apellido = params.apellido;
		}


		if (params.estado) {
			let estado =
				params.estado === "habilitado"
					? "H"
					: params.estado === "deshabilitado"
						? "D"
						: "";
			_params.habilitado = estado;
		}

		if (params.rows) {
			_params.rows = params.rows;
		}

		if (params.first) {
			_params.first = params.first;
		}
	}


	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getMedico = async (params) => {
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const saveMedico = async (actionCrud, item) => {
	let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;

	try {
		let response = {};
		if (actionCrud === "new") {
			response = await axios({
				method: "POST",
				url: `${urlCoreBack}${epName}`,
				data: item,
			});
		} else if (actionCrud === "update") {
			response = await axios({
				method: "PUT",
				url: `${urlCoreBack}${epName}`,
				data: item,
			});
		} else if (actionCrud === "disable" || actionCrud === "enable") {
			response = await axios({
				method: "DELETE",
				url: `${urlCoreBack}${epName}`,
				params: {
					id: item.id,
					action: actionCrud,
				},
			});
		}

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				response.messageText =
					`${nameItemText}` +
					(actionCrud === "disable"
						? itemGender === "M"
							? " deshabilitado"
							: " deshabilitada"
						: actionCrud === "enable"
							? itemGender === "M"
								? " habilitado"
								: " habilitada"
							: itemGender === "M"
								? " guardado"
								: " guardada");
				response.messageSeverity = "success";
				return response;
			}

			if (response.data.code === "err-medico-already-exist") {
				response.ok = false;
				response.messageText = "Ya existe un Médico con la misma descripción";
				response.messageSeverity = "error";
				return response;
			}
		}

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;

	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
